import { createAction, props } from '@ngrx/store';
import { CurrentUsageFeaturesPlan, EntitlementResponse, EntitlementsError, Subscription } from '../types/entitlements.types';

export const loadEntitlements = createAction('[Entitlements] Load Entitlements');

export const loadEntitlementsSuccess = createAction(
  '[Entitlements] Load Entitlements Success',
  props<{ entitlements: EntitlementResponse }>()
);

export const loadEntitlementsFailure = createAction(
  '[Entitlements] Load Entitlements Failure',
  props<{ error: EntitlementsError }>()
);

export const setCurrentUsageFeaturesPlan = createAction(
  '[Entitlements] Set Current Usage Features Plan',
  props<{ currentUsageFeaturesPlan: CurrentUsageFeaturesPlan }>()
);

export const clearEntitlementsError = createAction('[Entitlements] Clear Error');

// Schedule cancel
export const scheduleCancelSubscription = createAction(
  '[Entitlements] Schedule Cancel Subscription',
  props<{ subscriptionId: string }>()
);

export const scheduleCancelSubscriptionSuccess = createAction(
  '[Entitlements] Schedule Cancel Subscription Success',
  props<{ subscription: Subscription }>()
);

export const scheduleCancelSubscriptionFailure = createAction(
  '[Entitlements] Schedule Cancel Subscription Failure',
  props<{ error: EntitlementsError }>()
);

// Reactivate
export const reactivateSubscription = createAction(
  '[Entitlements] Reactivate Subscription',
  props<{ subscriptionId: string }>()
);

export const reactivateSubscriptionSuccess = createAction(
  '[Entitlements] Reactivate Subscription Success',
  props<{ subscription: Subscription }>()
);

export const reactivateSubscriptionFailure = createAction(
  '[Entitlements] Reactivate Subscription Failure',
  props<{ error: EntitlementsError }>()
);
